import * as R from 'ramda'

const configState = R.pathOr({}, ['config'])

const apps = R.pipe(
  configState,
  R.prop('apps')
)

const common = R.pipe(
  configState,
  R.propOr({}, 'common')
)

const terms = R.pipe(
  common,
  R.prop('terms')
)

const insights = R.pipe(
  common,
  R.prop('insights')
)

const keycloak = R.pipe(
  common,
  R.prop('keycloak')
)

const environment = R.pipe(
  common,
  R.path(['environment', 'type'])
)

const region = R.pipe(
  common,
  R.pathOr('', ['environment', 'region']),
  R.toLower
)

const merchantSupport = R.pipe(
  common,
  R.prop('merchantSupport')
)

const nko = R.pipe(
  common,
  R.prop('nko')
)

const privacy = R.pipe(
  common,
  R.prop('privacy')
)

const getMerchantPortalBaseUrl = R.pipe(
  common,
  R.prop('merchantPortalBaseUrl')
)

const appCategories = R.pipe(
  common,
  R.prop('appCategories')
)

const isOneTrustEnabled = R.pipe(
  common,
  R.pathOr(false, ['oneTrust', 'enabled'])
)

const educationFeatures = R.pipe(
  common,
  R.prop('educationFeatures')
)

const canOverrideEducationFeatures = R.pipe(
  educationFeatures,
  R.propOr(false, 'canOverride')
)

export {
  apps,
  terms,
  insights,
  keycloak,
  environment,
  region,
  merchantSupport,
  nko,
  privacy,
  getMerchantPortalBaseUrl,
  appCategories,
  isOneTrustEnabled,
  canOverrideEducationFeatures
}
